import { RadioButtonNew, RadioGroupNew } from "@octopusdeploy/design-system-components";
import { ExpandableFormSection, Summary } from "~/components/form";
type NewProjectDashboardDataSourceProps = {
    isEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
};
export function ProjectsPageOptimization({ isEnabled, onChange }: NewProjectDashboardDataSourceProps) {
    const description = "Changes the projects page to use new optimized endpoint.";
    const label = "Projects Page Optimization";
    return (<ExpandableFormSection key="IsProjectsPageOptimizationEnabled" errorKey="IsProjectsPageOptimizationEnabled" title={label} summary={isEnabled ? Summary.summary("Enabled") : Summary.default("Disabled")} help={description}>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name="ProjectsPageOptimization"/>
                <RadioButtonNew value={false} label="Disabled" hasDefaultMarker={true} name="ProjectsPageOptimization"/>
            </RadioGroupNew>
        </ExpandableFormSection>);
}
